/* @HEADER
 * @version 1.1.289 | 2026-10-18
 * @purpose What AppShell mounted inline for the command palette — the palette itself and, beside it, the hint for a card that «Подсветить на доске» found in another space (ZVX-3530). Same palette, its own file, so the shell does not grow.
 * @sidecar PaletteMount.tsx.header.md
 * @layer app | @hex adapter | @ctx search
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-7685, ZVX-DEV-7414

import { CommandPalette } from '../features/kanban/public-api';
import { SearchElsewhereNotice } from './SearchElsewhereNotice';
import type { PaletteController } from './usePaletteController';

export interface PaletteMountProps {
  palette: PaletteController;
  /** True while a space is on screen (the palette scopes its search to it). */
  currentSpaceActive: boolean;
}

export function PaletteMount({ palette, currentSpaceActive }: PaletteMountProps) {
  return (
    <>
      <CommandPalette
        open={palette.open}
        onClose={palette.close}
        items={palette.items}
        onSelect={palette.onSelect}
        initialQuery={palette.initialQuery}
        openVia={palette.openVia}
        currentSpaceActive={currentSpaceActive}
      />
      {palette.elsewhere && (
        <SearchElsewhereNotice
          spaceName={palette.elsewhere.spaceName}
          onGo={palette.goElsewhere}
          onClose={palette.dismissElsewhere}
        />
      )}
    </>
  );
}
